<h2 mat-dialog-title *ngIf="!isNew" class="bg-blue text-white">PEO Client-Customer Information Modification</h2>
<h2 mat-dialog-title *ngIf="isNew && !peoId && !data.client?.peoId" class="bg-blue text-white">New PEO Client-Customer
  Information</h2>
<h2 mat-dialog-title *ngIf="isNew && (!!peoId || !!data.client?.peoId)" class="bg-blue text-white">New Client-Customer
  Information for PEO {{ peoId || data.client?.peoId }}</h2>
<mat-dialog-content>
  <p *ngIf="data.client?.peoId && data.client?.clientId">Use the form below to fill out the information for
    the {{ data.client?.peoId }} PEO Client-Customer Mapping for {{ data.client?.clientId }}.</p>
  <p *ngIf="!data.client?.peoId || !data.client?.clientId">Use the form below to fill out the information for the new
    PEO
    Client-Customer Mapping.</p>
  <form [formGroup]="form" class="app-form">
    <fieldset>

      <!-- PEO ID -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>PEO ID</mat-label>
        <input matInput [formControl]="form.controls.peo" [matAutocomplete]="appAutoCompletePeo"
               [readonly]="!!data.client?.peoId || !!peoId"
               placeholder="Type a PEO Name or ID" type="text">
        <mat-autocomplete [requireSelection]="!(data.client?.peoId ?? peoId)" [displayWith]="displayPeoValue"
                          #appAutoCompletePeo="matAutocomplete">
          @for (p of peoListFiltered | async; track p) {
            <mat-option [value]="p">{{ displayPeoValue(p) }}</mat-option>
          }
        </mat-autocomplete>
        <mat-spinner *ngIf="loadingPeoList" matSuffix color="warn" diameter="18"
                     style="margin-right: 10px;"></mat-spinner>

        <mat-error *ngIf="form.controls.peo?.hasError('required')">
          A unique PrismHR identifier for the PEO is required.
        </mat-error>
        <mat-hint *ngIf="!data.client?.peoId && !peoId">
          Type in a PrismHR PEO ID then click on the desired option.
          At least 3 characters are required to trigger the search.
        </mat-hint>
      </mat-form-field>

      <!-- Client ID -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Client ID</mat-label>
        <input matInput [disabled]="formDisabled || loadingPeoList" [formControl]="form.controls.clientId"
               [readonly]="!!data.client?.clientId" type="text">
        <mat-error *ngIf="form.controls.clientId?.hasError('required')">
          A unique PrismHR identifier for the Client is required.
        </mat-error>
        <mat-hint>This should be exactly what appears in PrismHR. If an asterisk &lpar;<code>&ast;</code>&rpar;
          is in the Client ID in PrismHR, it must be included here as well.
        </mat-hint>
      </mat-form-field>
    </fieldset>
    <fieldset>

      <!-- Customer ID -->
      <mat-form-field class="app-form-field-whole" floatLabel="always">
        <mat-label>Customer ID</mat-label>
        <input matInput (input)="filterCustomerList(inputCustomer.value)" [formControl]="form.controls.customer"
               [matAutocomplete]="appAutoCompleteCustomer"
               placeholder="Type a Customer Name or ID" type="text" #inputCustomer>
        <mat-autocomplete [displayWith]="displayCustomerValue" [requireSelection]="true"
                          #appAutoCompleteCustomer="matAutocomplete">
          @for (c of customerList | async; track c) {
            <mat-option *ngIf="!!c" [value]="c">{{ displayCustomerValue(c) }}</mat-option>
          }
        </mat-autocomplete>
        <mat-spinner *ngIf="loadingCustomerList" matSuffix color="warn" diameter="18"
                     style="margin-right: 10px;"></mat-spinner>
        <mat-error *ngIf="form.controls.peo?.hasError('required')">
          A SyncStream Customer association is required.
        </mat-error>
        <mat-hint>
          Type in a SyncStream Customer ID or Name then click on the desired option.
          At least 3 characters are required to trigger the search.
        </mat-hint>
      </mat-form-field>
    </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">

  <!-- Cancel and close the dialog. -->
  <button mat-button (click)="cancel()" color="icon-slate">
    <mat-icon>cancel</mat-icon>
    Cancel
  </button>

  <!-- Save the form data. -->
  <button mat-button (click)="save()" [disabled]="form.invalid || formDisabled || loadingPeoList || loadingCustomerList"
          matTooltip="Commit the PEO Client-Customer Maping to persistent storage." color="icon-green">
    <mat-icon>save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
